import { useEffect } from 'react';

export const SITE_URL = 'https://www.grandsummoners.info';
export const SITE_NAME = 'Grand Summoners Database';
export const DEFAULT_DESCRIPTION =
    'The unofficial fansite for Grand Summoners. Browse unit and equipment databases, tierlists, changelogs, and player guides.';

function upsertMeta(selector, attributes) {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('meta');
        document.head.appendChild(element);
    }
    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
}

function upsertLink(rel, href) {
    let element = document.head.querySelector(`link[rel="${rel}"]`);
    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', rel);
        document.head.appendChild(element);
    }
    element.setAttribute('href', href);
}

export default function PageMeta({
    title,
    description = DEFAULT_DESCRIPTION,
    path = '/',
    image = '/logo.png',
    noIndex = false,
}) {
    useEffect(() => {
        const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
        const canonicalUrl = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
        const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`;

        document.title = pageTitle;

        upsertMeta('meta[name="description"]', { name: 'description', content: description });
        upsertMeta('meta[property="og:title"]', { property: 'og:title', content: pageTitle });
        upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
        upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl });
        upsertMeta('meta[property="og:image"]', { property: 'og:image', content: imageUrl });
        upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
        upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE_NAME });
        upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
        upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: pageTitle });
        upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
        upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: imageUrl });
        upsertMeta('meta[name="robots"]', {
            name: 'robots',
            content: noIndex ? 'noindex, nofollow' : 'index, follow',
        });

        upsertLink('canonical', canonicalUrl);
    }, [title, description, path, image, noIndex]);

    return null;
}
